import { productsAndServicesApi } from 'api';

export const updateCase = async (caseID: string) => {
  return await productsAndServicesApi.updateOfferings({ caseId: Number(caseID) });
};
